import { defineStore } from 'pinia';

export type PayrollState = {
    employeeName: string;
    employeeId: number;
    value: number;
    gageModalOpen: boolean;
    lunchArrangementMonthlyModalOpen: boolean;
    fixedAddOnsMonthlyModalOpen: boolean;
    hourlyRateModalOpen: boolean;
};

export const usePayrollStore = defineStore('payroll', {
    state: (): PayrollState => ({
        employeeName: '',
        employeeId: 0,
        value: 0,
        gageModalOpen: false,
        lunchArrangementMonthlyModalOpen: false,
        fixedAddOnsMonthlyModalOpen: false,
        hourlyRateModalOpen: false,
    }),
    getters: {},
    actions: {
        openModal(
            alert: 'gage' | 'lunch_arrangement_monthly' | 'fixed_add_ons_monthly' | 'hourly_rate',
            employeeName: string,
            employeeId: number,
            value: number,
        ) {
            this.setData(employeeName, employeeId, value);

            this.toggleModal(alert, true);
        },
        toggleModal(
            alert: 'gage' | 'lunch_arrangement_monthly' | 'fixed_add_ons_monthly' | 'hourly_rate',
            open: boolean,
        ) {
            switch (alert) {
                case 'gage':
                    this.gageModalOpen = open;
                    break;
                case 'lunch_arrangement_monthly':
                    this.lunchArrangementMonthlyModalOpen = open;
                    break;
                case 'fixed_add_ons_monthly':
                    this.fixedAddOnsMonthlyModalOpen = open;
                    break;
                case 'hourly_rate':
                    this.hourlyRateModalOpen = open;
                    break;
            }
        },
        clearData() {
            this.employeeName = '';
            this.employeeId = 0;
            this.value = 0;
        },
        setData(employeeName: string, employeeId: number, value: number) {
            this.employeeName = employeeName;
            this.employeeId = employeeId;
            this.value = value;
        },
    },
});
